import React from 'react';
import PropTypes from 'prop-types';

function LeftCol(props) {
  const {
    title,
    info,
    image,
    institution,
  } = props;
  const sector = info.find(element => element.name === 'Sector');
  const solucion = info.find(element => element.name === 'Solución');
  const descripcion = info.find(element => element.name === 'Descripción');
  const necesidad = info.find(element => element.name === 'Necesidad');
  const ventajas = info.find(element => element.name === 'Ventajas');
  const oportunidad = info.find(element => element.name === 'Oportunidad de negocio');
  const estado = info.find(element => element.name === 'Estado del proyecto');
  const institutions = institution.split('-');
  const titleClasses = [
    'h1',
    'page-title',
    'underline',
    'underline_green',
    `page-title--${institutions[0].toLowerCase()}`,
  ].join(' ');

  function addingListItems(data) {
    let item;
    switch (data.type) {
      case 'java.lang.String':
        if (data.name === 'Oportunidad de negocio') {
          item = data.value;
        } else {
          item = <p>{data.value}</p>;
        }
        break;
      case 'java.util.List':
        item = (
          <ul>
            {
              data.value.map(itemList => itemList && (
                <li>{itemList}</li>
              ))
            }
          </ul>
        );
        break;
      default:
        item = '';
        break;
    }
    return item;
  }

  return (
    <div className="licensed-technology-left-col">
      <div className="page-title__wrapper">
        <h1 className={titleClasses}>
          {title}
        </h1>
      </div>
      {sector && (
        <div className="licensed-technology-left-col__sector">
          <h2 className="licensed-technology-left-col__sector-title">
            Sector de aplicación
          </h2>
          {addingListItems(sector)}
        </div>
      )}
      {estado && (
        <p className="licensed-technology-left-col__technology_level">
          <h2 className="licensed-technology-left-col__technology_level-title">
            Nivel de madurez tecnológica
          </h2>
          <span dangerouslySetInnerHTML={{__html: estado.value}} /> {/* eslint-disable-line */}
        </p>
      )}
      <div className="licensed-technology-left-co__content">
        <div className="licensed-technology-left-col__solution">
          <img
            src={`http://startups.hipatia.cr/files/soi/${image}`}
            className="licensed-technology-left-col__img"
            alt=""
          />
          {solucion && (
            <div>
              <h2 className="licensed-technology-left-col__title">Solución</h2>
              <div dangerouslySetInnerHTML={{ __html: solucion.value }} /> {/* eslint-disable-line */}
            </div>
          )}
        </div>
        {descripcion && (
          <div className="licensed-technology-left-col__description">
            <h2 className="licensed-technology-left-col__title">Descripción</h2>
            <div dangerouslySetInnerHTML={{ __html: descripcion.value }} /> {/* eslint-disable-line */}
          </div>
        )}
        {necesidad && (
          <div className="licensed-technology-left-col__necessity">
            <h2 className="licensed-technology-left-col__title">Necesidad</h2>
            <div dangerouslySetInnerHTML={{ __html: necesidad.value }} /> {/* eslint-disable-line */}
          </div>
        )}
        {ventajas && (
          <div className="licensed-technology-left-col__advantage">
            <h2 className="licensed-technology-left-col__title">Ventajas</h2>
            <p dangerouslySetInnerHTML={{ __html: ventajas.value }} /> {/* eslint-disable-line */}
          </div>
        )}
        {oportunidad && (
          <div className="licensed-technology-left-col__opportunity">
            <h2 className="licensed-technology-left-col__title">Oportunidad de negocio</h2>
            {
              oportunidad.type === 'java.util.List'
                ? addingListItems(oportunidad)
                : <div dangerouslySetInnerHTML={{ __html: addingListItems(oportunidad) }} /> /* eslint-disable-line */
            }
          </div>
        )}
      </div>
    </div>
  );
}

LeftCol.propTypes = {
  title: PropTypes.string.isRequired,
  info: PropTypes.arrayOf(PropTypes.object).isRequired,
  image: PropTypes.string.isRequired,
  institution: PropTypes.string.isRequired,
};

export default LeftCol;
